import axios from 'axios';
import localStorage from '../../../../utils/localStorage';
import { API_QUERYBUILDER } from '../../../../commons/api';

const token = localStorage.get('accessToken');
var Authorization = 'Bearer ' + token;
export async function getTableNames(selectSchema) {
  let siteId = localStorage.get('currentSite');
  let data = await fetch(
    `${API_QUERYBUILDER.GetTableList}?SiteId=${siteId}&schema=${selectSchema}`,
    {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json;
    })
    .catch(() => {
      // if(error.response.data.name === 'TokenExpiredError'){
      //   jwtToken(error.response.data.message)
      // }
    });

  return data === undefined ? [] : data;
}
export async function getSchemaList() {
  let siteId = localStorage.get('currentSite');
  let data = await fetch(`${API_QUERYBUILDER.GetSchema}?SiteId=${siteId}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json;
    })
    .catch(() => {
      // if(error.response.data.name === 'TokenExpiredError'){
      //   jwtToken(error.response.data.message)
      // }
    });

  return data === undefined ? [] : data;
}
export async function getList(payload) {
  let siteId = localStorage.get('currentSite');
  let data = await fetch(
    `${API_QUERYBUILDER.GetFunctionsDropDown}?SiteId=${siteId}&Type=${payload.Type}`,
    {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json;
    })
    .catch(() => {
      // if(error.response.data.name === 'TokenExpiredError'){
      //   jwtToken(error.response.data.message)
      // }
    });

  return data === undefined ? [] : data;
}
export async function getOperatorList() {
  const url = `${API_QUERYBUILDER.OperatorList}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: Authorization
    }
  };
  fetch(url, options)
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.log(error);
    });
}
export async function createQuery(payload) {
  const siteId = localStorage.get('currentSite');
  const options = {
    method: 'POST',
    url: `${API_QUERYBUILDER.CREATEQUERY}?SiteId=${siteId}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: Authorization
    },
    data: payload
  };
  return axios(options)
    .then((response) => {
      return response.data;
    })
    .catch(function () { });
}
